import instance from '../Service'

export default class Auth {
  static async login(data) {
    try {
      const response = await instance.post('/auth/login', data, {
        withCredentials: true
      });
      return response;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  }
  
  static async register(data) {
    return instance.post('/auth/register', data, {
      withCredentials: true
    })
  }

  static async google_register(data) {
    return instance.post('/auth/google/register', data, {
      withCredentials: true
    })
  }

  static async verification(data) {
    return instance.post('/auth/verification', data, {
      withCredentials: true
    })
  }

  static async logout() {
    return instance.post('/auth/logout', {}, {
      withCredentials: true
    })
  }

  static async verifyAuth() {
    try {
      const response = await instance.get('/auth/verify', {
        withCredentials: true
      });
      return response;
    } catch (error) {
      console.error('Verify auth error:', error);
      throw error;
    }
  }

  static async refreshToken() {
    try {
      const response = await instance.post('/auth/refresh', {}, {
        withCredentials: true
      });
      return response;
    } catch (error) {
      console.error('Refresh token error:', error);
      throw error;
    }
  }

  static async resendVerificationCode(email) {
    return instance.post('/auth/resend-verification', { email }, {
      withCredentials: true
    })
  }
}